export const ENCRYPTABLE_METHODS = new Set(['POST', 'PUT', 'PATCH']);
